import {
  Box,
  Button,
  IconButton,
  InputLabel,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import { Col, Form, Row } from "react-bootstrap";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import React, { useEffect, useRef, useState } from "react";
import {
  downloadFile,
  GetARFDocuments,
  getDownstreamSummaryData,
} from "../../api/downstreamSummaryApi/downstreamSummaryApi";
import ExcelIcon from "../../assets/images/ExcelExport.png";
import PushPinIcon from "@mui/icons-material/PushPin";
import "react-datepicker/dist/react-datepicker.css";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-enterprise";
import { PreworksummaryModelDetails } from "../../types/PreworksummaryModel";
import moment from "moment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import InfoIcon from "@mui/icons-material/Info";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import HistoryIcon from "@mui/icons-material/History";
import SearchIcon from "@mui/icons-material/Search";
import MailIcon from "@mui/icons-material/Mail";
import InfoDrawer from "../SimpleSearch/InfoDrawer";
import AssetHistory from "../Alert/AssetHistory";
import "../../config/colors.css";
import { UserGridPreferenceModel } from "../../types/UserGridPreferenceModel";
import {
  getUserGridPreference,
  saveUserGridPreference,
} from "../../api/userDataApi/userGridPreferenceAPI";
import CopyToClipboardPopup from "../Alert/CopytoClipboardPopup";
import EmailDocument from "../Alert/EmailDocument";
import { DownstreamreprocessModel } from "../../types/DownstreamreprocessModel";
import ClearIcon from "@mui/icons-material/Clear";
import { useLoader } from "../../context/LoaderContext";
import { ARFDocument } from "../../types/ARFDocumentModel";
import ConfirmationAlert from "../Alert/ConfirmationAlert";
import { UserModel } from "../../types/userDataModel";
import DownstreamSubSystemReprocessPopup from "../Alert/DownstreamSubSystemReprocessPopup";
import DownstreamFDReprocesspopup from "../Alert/DownstreamFDReprocesspopup";
import CustomLoadingOverlay from "../CustomLoadingOverlay/CustomLoadingOverlay ";
import { useSnackbar } from "../Common/SnackbarContext";
import { appSettings } from "../../config/appSetting";
import { urlConfig } from "../../config/urlConfig";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { FormatDate } from "../Common/CommonMethods";
import isPagePermission from "../../utils/common";
import LocalStorageUtil from "../../utils/localStorage";
import { multipleDownloadFile } from "../../api/simpleSearchApi/simpleSearchApi";
interface ChildComponentProps {
  email: string;
  businessUnitData: any;
}
const DownstreamSummary: React.FC<ChildComponentProps> = ({
  email,
  businessUnitData,
}) => {
  const { setLoading } = useLoader();
  const [gridRecordExist, setGridRecordExist] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>(() => {
    const newDate = new Date();
    newDate.setDate(newDate.getDate() - 1);
    return newDate;
  });
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const pageSizeSelector = appSettings.agGridPageSizeSelector;
  const defaulPageSize = appSettings.agGridDefaulPageSize;
  const [columnDefs, setColumnDefs] = useState<ColDef[]>([]);
  const [rowData, setRowData] = useState<any[]>();
  const gridRef = useRef<AgGridReact>(null);
  const [tabType, setTabType] = useState<number>(2);
  const [activeButton, setActiveButton] = useState<string>("");
  const [inProcessCount, setInProcessCount] = useState<number>(0); // In-Process tab count
  const [completedCount, setCompletedCount] = useState<number>(0); // Completed tab count
  const [allCount, setAllCount] = useState<number>(0); // All tab count
  const [selectedDocument, setSelectedDocument] = useState<any>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const toggleDrawer = (open: boolean) => () => {
    setDrawerOpen(open);
  };

  const [showIconButton, setShowIconButton] = useState<boolean>(false);
  const { showSnackbar } = useSnackbar();
  const [_dialogOpen, set_DialogOpen] = useState(false); // NOSONAR
  const [assetHistoryOpen, setAssetHistoryOpen] = useState(false);
  const [assetHistoryData, setAssetHistoryData] = useState<any>(null);
  const [exceptionOpen, setExceptionOpen] = useState(false);
  const [exceptionData, setExceptionData] = useState<any>(null);
  const [emailDocumentOpen, setEmailDocumentOpen] = useState(false);
  const [emailDocumentData, setEmailDocumentData] = useState<any>(null);
  const [searchContent, setsearchContent] = useState<string>("");
  const [_searchContentError, set_SearchContentError] = useState<string>(""); // NOSONAR
  const [isAccountDAOEnabled, setIsAccountDAOEnabled] = useState<boolean>(true);
  const [isAccountDSAEnabled, setIsAccountDSAEnabled] =
    useState<boolean>(false);
  const [, setIsAccountEdeliveryEnabled] = useState<boolean>(true); // NOSONAR
  const [loggedUserData, setLoggedUserData] = useState<UserModel | null>(null);
  let emailIcon = false;
  const [_gridApi, set_GridApi] = useState<any>(); // NOSONAR
  const [_pagePermission, set_PagePermission] = useState<any>(null); // NOSONAR
  const getLoogedUserData = async () => {
    try {
      const userData = LocalStorageUtil.getItem("authorizationData");
      if (userData) {
        set_PagePermission(JSON.parse(userData).pageControlPermission);
        setLoggedUserData(JSON.parse(userData));
        setIsAccountDAOEnabled(
          LocalStorageUtil.getItem("isAccountDAOEnabled") === "True",
        );
        setIsAccountDSAEnabled(
          LocalStorageUtil.getItem("isAccountDSAEnabled") === "True",
        );
        setIsAccountEdeliveryEnabled(
          LocalStorageUtil.getItem("isAccountEdeliveryEnabled") === "True",
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getLoogedUserData();
  }, []);
  // On page load to show data for In-Process tab
  useEffect(() => {
    const init = async () => {
      // Check if required localStorage items exist
      if (
        LocalStorageUtil.getItem("userId") &&
        LocalStorageUtil.getItem("contextName") &&
        LocalStorageUtil.getItem("token")
      ) {
        const parameter: PreworksummaryModelDetails = {
          AccountId:
            businessUnitData?.accountId ||
            Number(LocalStorageUtil.getItem("accountId")),
          Fromdate: startDate,
          Todate: endDate,
          Search: undefined,
          SortColumn: "",
          SortOrder: 0,
          Documentstatus: isPagePermission(
            "Allow Downstream Inprogress",
            "Downstream",
            1344,
          )
            ? 2
            : 3,
          CurrentPage: 0,
          NoOfRecords: 0,
          Datebasedocid: undefined,
          Timezone: appSettings.timezone,
          PageLoadFlag: true,
          UserId: Number(LocalStorageUtil.getItem("userId")),
          IsSuperAdmin: 1,
          FolderRights: false,
          ContextName:
            businessUnitData?.contextName ||
            LocalStorageUtil.getItem("contextName")?.toString(),
        };
        // Fetch data only after the condition is met
        await fetchData(parameter);
        // Set the active button to In-Process
        isPagePermission("Allow Downstream Inprogress", "Downstream", 1344)
          ? setActiveButton("IN-PROCESS")
          : setActiveButton("COMPLETED");
      } else {
        console.warn("Required localStorage items not found.");
      }
    };

    init(); // Call the async function
  }, []); // Dependency array remains empty to run only once

  // Apply button click event
  const handleApplyButton = () => {
    emailIcon = tabType === 3;
    if (startDate && endDate && startDate > endDate) {
      showSnackbar("From date should be less than To date", true);
    } else {
      const parameter: PreworksummaryModelDetails = {
        AccountId: businessUnitData?.accountId ?? loggedUserData?.accountId,
        Fromdate: startDate,
        Todate: endDate,
        Search: searchContent,
        SortColumn: "",
        SortOrder: 0,
        Documentstatus: tabType,
        CurrentPage: 0,
        NoOfRecords: 0,
        Datebasedocid: undefined,
        Timezone: appSettings.timezone,
        PageLoadFlag: true,
        UserId: Number(LocalStorageUtil.getItem("userId")),
        IsSuperAdmin: 1,
        FolderRights: false,
        ContextName:
          businessUnitData?.contextName ||
          LocalStorageUtil.getItem("contextName")?.toString(),
      };
      fetchData(parameter);
    }
  };

  // handel In-Process tab click event
  const handleInProcessTabClick = (tabType: number, buttonName: string) => {
    setActiveButton(buttonName);
    setTabType(tabType);
    emailIcon = false;
    const parameter: PreworksummaryModelDetails = {
      AccountId: businessUnitData?.accountId || loggedUserData?.accountId,
      Fromdate: startDate ?? null,
      Todate: endDate,
      Search: searchContent,
      SortColumn: "",
      SortOrder: 0,
      Documentstatus: tabType,
      CurrentPage: 0,
      NoOfRecords: 0,
      Datebasedocid: undefined,
      Timezone: appSettings.timezone,
      PageLoadFlag: true,
      UserId: Number(LocalStorageUtil.getItem("userId")),
      IsSuperAdmin: 1,
      FolderRights: false,
      ContextName:
        businessUnitData?.contextName ||
        LocalStorageUtil.getItem("contextName")?.toString(),
    };
    fetchData(parameter);
  };

  // handel Completed tab click event
  const handleCompletedTabClick = (tabType: number, buttonName: string) => {
    setActiveButton(buttonName);
    setTabType(tabType);
    emailIcon = true;
    const parameter: PreworksummaryModelDetails = {
      AccountId: businessUnitData?.accountId || loggedUserData?.accountId,
      Fromdate: startDate,
      Todate: endDate,
      Search: searchContent,
      SortColumn: "",
      SortOrder: 0,
      Documentstatus: tabType,
      CurrentPage: 0,
      NoOfRecords: 0,
      Datebasedocid: undefined,
      Timezone: appSettings.timezone,
      PageLoadFlag: true,
      UserId: Number(LocalStorageUtil.getItem("userId")),
      IsSuperAdmin: 1,
      FolderRights: false,
      ContextName:
        businessUnitData?.contextName ||
        LocalStorageUtil.getItem("contextName")?.toString(),
    };
    fetchData(parameter);
  };

  // handel All tab click event
  const handleAllTabClick = (tabType: number, buttonName: string) => {
    setActiveButton(buttonName);
    setTabType(tabType);
    emailIcon = false;
    const parameter: PreworksummaryModelDetails = {
      AccountId: businessUnitData?.accountId || loggedUserData?.accountId,
      Fromdate: startDate,
      Todate: endDate,
      Search: searchContent,
      SortColumn: "",
      SortOrder: 0,
      Documentstatus: tabType,
      CurrentPage: 0,
      NoOfRecords: 0,
      Datebasedocid: undefined,
      Timezone: appSettings.timezone,
      PageLoadFlag: true,
      UserId: Number(LocalStorageUtil.getItem("userId")),
      IsSuperAdmin: 1,
      FolderRights: false,
      ContextName:
        businessUnitData?.contextName ||
        LocalStorageUtil.getItem("contextName")?.toString(),
    };
    fetchData(parameter);
  };

  //Rename the columns
  const renameColumns = (val: any) => {
    if (val !== undefined) {
      if (val.toLowerCase() === "ngfamily_id") {
        return "Family_Id";
      } else if (val.toLowerCase() === "project_id") {
        return "Document ID";
      } else if (val.toLowerCase() === "statement_date") {
        return "Date";
      } else if (val.toLowerCase() === "sub_dob") {
        return "DateOfBirth";
      } else if (val.toLowerCase() === "sub_name") {
        return "Name";
      } else if (val.toLowerCase() === "lastmodifieddate") {
        return "Last Modified Date";
      } else if (val.toLowerCase() === "level 1") {
        return "Rendition";
      } else {
        return val.replace(/&amp;/, "&");
      }
    }
  };

  // Fetch data from API

  const getDynamicColumns = (
    response: any,
    columnsToExclude: string[],
    renameColumns: (val: any) => string,
  ) => {
    return Object.keys(response[0])
      .filter((key) => !columnsToExclude.includes(key))
      .map((key: string) => {
        if (
          (key.toLowerCase().includes("date") &&
            key.toLocaleLowerCase() !== "aws date" &&
            key.toLocaleLowerCase() !== "document date") ||
          key.toLowerCase() === "uploaded on" ||
          key.toLowerCase() === "aws date"
        ) {
          return {
            headerName: renameColumns(
              key.charAt(0).toUpperCase() + key.slice(1),
            ),
            field: key,
            sortable: true,
            filter: true,
            enableRowGroup: true,
            valueFormatter: (params: any) => {
              return FormatDate(params.value);
            },
          };
        } else {
          return {
            headerName: renameColumns(
              key.charAt(0).toUpperCase() + key.slice(1),
            ),
            field: key,
            sortable: true,
            filter: true,
            enableRowGroup: true,
          };
        }
      });
  };

  // Helper to get combined column definitions
  const getCombinedColumnDefs = (
    dynamicColumns: any[],
    returnStatusRenderer: any,
    ActionCellRenderer: any,
  ) => [
    {
      width: 10,
      sortable: false,
      filter: false,
      hide: false,
      colId: "colCheckbox",
      enableRowGroup: false,
      resizable: false,
    },
    {
      headerName: "#",
      width: 70,
      colId: "colRowNum",
      sortable: false,
      filter: false,
      resizable: false,
      enableRowGroup: false,
      valueGetter: (params: any) => {
        return params.node ? (params.node.rowIndex ?? 0) + 1 : 0;
      },
    },
    ...dynamicColumns,
    {
      field: "ReturnStatus",
      headerName: "Return Status",
      sortable: true,
      filter: false,
      enableRowGroup: false,
      hide:
        LocalStorageUtil.getItem("isAccountDAOEnabled")?.toLowerCase() !==
        "true",
      cellClass: "actions-button-cell",
      cellRenderer: returnStatusRenderer,
      colId: "colReturnStatus",
      width: 150,
    },
    {
      field: "Actions",
      headerName: "Actions",
      sortable: false,
      enableRowGroup: false,
      pinned: "right",
      lockPinned: true,
      suppressSizeToFit: false,
      width: 200,
      minWidth: 200,
      cellClass: "actions-button-cell",
      cellRenderer: ActionCellRenderer,
      filter: false,
      resizable: true,
      colId: "colAction",
    },
  ];

  const fetchData = async (params: any) => {
    try {
      setShowLoader(true);
      set_SearchContentError("");
      const response = await getDownstreamSummaryData(params);

      if (response !== undefined && response[0].RecordCounts > 0) {
        // Set grid preferences
        const gridPreferences = await getUserGridPreferences();
        if (gridPreferences) {
          applyGridPreferences(gridPreferences);
          showSnackbar("Grid state applied successfully.");
        }

        setInProcessCount(response[0].InProgress);
        setCompletedCount(response[0].Completed);
        setAllCount(response[0].AllCount);

        // Define columns to exclude
        const columnsToExclude = [
          "RowNum",
          "OrderbyLatestDoc",
          "AllCount",
          "Completed",
          "InProgress",
          "RecordCounts",
          "DocumentStatus",
          "Filetype",
          "documenttype",
          "Instructions",
          "DocumentStreamID",
          "DocumentID",
          "DownloadFileName",
          "Filecount",
          "Is Previous Document latest?",
          "Page Size",
          "Project Description",
          "Fund Name",
          "AgentFirstName",
          "AgentLastName",
          "dao_flag",
          "selected",
          "DAOReurn",
          "DSAreurn",
          "EdeliveryReturn",
          "DocumentStatusValue",
          "DAOflag",
          "DocumentRuleIdCounts",
          "DisplayName",
          "AccessPermission",
          "SubSystemName",
          "SubSystemConfigurationId",
          "IsAllowSubSystemReprocess",
          "ParentDocumentStreamID",
          "FundFolderId",
          "StatusName",
        ];

        const dynamicColumns = getDynamicColumns(
          response,
          columnsToExclude,
          renameColumns,
        );
        const combinedColumnDefs = getCombinedColumnDefs(
          dynamicColumns,
          returnStatusRenderer,
          ActionCellRenderer,
        );

        setGridRecordExist(true);
        setRowData(response);
        setColumnDefs(combinedColumnDefs);
      } else {
        setInProcessCount(response[0].InProgress);
        setCompletedCount(response[0].Completed);
        setAllCount(response[0].AllCount);
        setColumnDefs([]);
        setRowData([]);
        setGridRecordExist(false);
      }
    } catch (error) {
      showSnackbar("Error in Downstream summary data fetching ", true);
    } finally {
      setShowLoader(false);
    }
  };

  //Handle Export to excel
  const handleExport = () => {
    if (gridRef.current) {
      gridRef.current.api.exportDataAsExcel({
        fileName:
          "DownstreamSummaryReports_" + moment().format("YYYYMMDD") + ".xlsx",
        sheetName: "DownstreamSummary Report",
        columnKeys: columnDefs
          .map((colDef) => colDef.field)
          .filter((field): field is string => typeof field === "string"), // NOSONAR
        processCellCallback: function (params) {
          return params.value;
        },
      });
    }
  };

  //handel reset button
  const handleReset = () => {
    const currentDate = new Date();
    currentDate.setUTCDate(currentDate.getUTCDate() - 1); // Set the default date range to 2 days
    setStartDate(currentDate);
    setEndDate(new Date());
    const parameter: PreworksummaryModelDetails = {
      AccountId: businessUnitData?.accountId || loggedUserData?.accountId,
      Fromdate: currentDate,
      Todate: new Date(),
      Search: undefined,
      SortColumn: "",
      SortOrder: 0,
      Documentstatus: tabType,
      CurrentPage: 0,
      NoOfRecords: 0,
      Datebasedocid: undefined,
      Timezone: appSettings.timezone,
      PageLoadFlag: true,
      UserId: Number(LocalStorageUtil.getItem("userId")),
      IsSuperAdmin: 1,
      FolderRights: false,
      ContextName:
        businessUnitData?.contextName ||
        LocalStorageUtil.getItem("contextName")?.toString(),
    };
    // Fetch data only after the condition is met
    fetchData(parameter);
    // Set the active button to In-Process
    setActiveButton("IN-PROCESS");
  };

  //Reapply grid state on component update
  useEffect(() => {
    const reapplyGridState = async () => {
      const gridPreferences = await getUserGridPreferences();
      if (gridPreferences) {
        applyGridPreferences(gridPreferences);
      }
    };
    reapplyGridState();
  }, [rowData]);

  //Save grid preferences
  const handleSaveGridPreferences = async () => {
    if (gridRef.current) {
      const gridState = gridRef.current.api.getColumnState();
      const userGridPreference: UserGridPreferenceModel = {
        Area: "DownstreamSummary",
        UserID: Number(LocalStorageUtil.getItem("userId")),
        BusinessUnitID: Number(LocalStorageUtil.getItem("businessUnitId")),
        ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
        GridBlob: JSON.stringify(gridState),
        LastModifiedBy: "DocDistro-UserGridPreferencesAPI",
        LastModifiedDate: new Date().toISOString(),
      };
      try {
        const workInProgressModelInfo =
          await saveUserGridPreference(userGridPreference);
        if (workInProgressModelInfo) {
          showSnackbar("Grid state successfully saved.");
        }
      } catch (error) {
        console.error("Error fetching data", error);
      }
    }
  };

  //Get grid preferences
  const getUserGridPreferences = async () => {
    const userGridPreference = {
      Area: "DownstreamSummary",
      UserID: Number(LocalStorageUtil.getItem("userId")),
      BusinessUnitID: Number(LocalStorageUtil.getItem("businessUnitId")),
      ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
    };
    try {
      const downstreamSummaryModelInfo =
        await getUserGridPreference(userGridPreference);
      return downstreamSummaryModelInfo;
    } catch (error) {
      showSnackbar("Error fetching data", true);
    } finally {
      setLoading(false);
    }
  };

  //Apply grid preferences
  const applyGridPreferences = (gridPreferences: any) => {
    if (gridPreferences) {
      try {
        const gridState = JSON.parse(gridPreferences);
        if (gridRef.current) {
          gridRef.current.api.applyColumnState({
            state: gridState,
            applyOrder: true,
          });

          gridRef.current.api.applyColumnState(gridState);
        }
      } catch (error) {
        console.error("Error parsing grid preferences:", error);
      }
    } else {
      console.warn("No grid preferences found or GridBlob is undefined.");
    }
  };

  //Return Status column for FD account
  const webReadyData = [{ Level1: "WEB-READY" }, { Level1: "CURRENT" }];

  const printReadyData = [
    { Level1: "PRINT-READY" },
    { Level1: "CURRENT (PRINT-READY VERSION)" },
  ];

  const CanEnableWebReady = (
    rowData: any,
    doumentId: number,
    type: number,
  ): boolean => {
    const item = rowData;
    if (item !== undefined) {
      if (type === 2) {
        const isExists = webReadyData.filter(
          (data) =>
            data.Level1.toUpperCase() ===
            item.DocumentStatusValue?.toUpperCase?.(),
        );
        return isExists.length > 0;
      } else {
        const isExists = printReadyData.filter(
          (data) =>
            data.Level1.toUpperCase() ===
            item.DocumentStatusValue?.toUpperCase?.(),
        );
        return isExists.length > 0;
      }
    }
    return false;
  };

  const returnStatusRenderer = (params: any) => {
    if (params.data === undefined) {
      return "";
    } else {
      return (
        <>
          {(isAccountDAOEnabled || isAccountDSAEnabled) &&
            CanEnableWebReady(params.data, params.data.DocumentStreamID, 1) && (
              <div className="bubbles-holder">
                {params.data.dao_flag === "Y" &&
                  (params.data.DAOReurn === null ||
                    params.data.DAOReurn === 0) && (
                    <span title="Export" className="export_circle">
                      P
                    </span>
                  )}
                {params.data.dao_flag === "N" &&
                  (params.data.DAOReurn === null ||
                    params.data.DAOReurn === 0) && (
                    <span title="Export" className="export_circle">
                      P
                    </span>
                  )}
                {params.data.DAOReurn !== null &&
                  params.data.DAOReurn === 1 && (
                    <span title="Return" className="return_circle">
                      P
                    </span>
                  )}
                {(params.data.DSAreurn === null ||
                  params.data.DSAreurn === 0) && (
                  <span title="Export" className="export_circle">
                    D
                  </span>
                )}
                {params.data.DSAreurn !== null &&
                  params.data.DSAreurn === 1 && (
                    <span title="Return" className="return_circle">
                      D
                    </span>
                  )}
              </div>
            )}
          {CanEnableWebReady(params.data, params.data.DocumentStreamID, 2) && (
            <div className="bubbles-holder">
              {(params.data.EdeliveryReturn === null ||
                params.data.EdeliveryReturn === 0) && (
                <span title="Export" className="export_circle">
                  E
                </span>
              )}
              {(params.data.EdeliveryReturn !== 0 ||
                params.data.EdeliveryReturn !== null) &&
                params.data.EdeliveryReturn === 1 && (
                  <span title="Return" className="return_circle">
                    E
                  </span>
                )}
            </div>
          )}
        </>
      );
    }
  };

  //Action cell renderer
  const ActionCellRenderer = (params: any) => {
    const rowData = params.data;
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const handleClick = (event: any) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = (actionType: number, rowData: any) => {
      // Delete
      if (actionType === 0) {
        handelDeleteContextMenuOption(rowData);
      }
      // Reprocess to Source
      else if (actionType === 1) {
        handleReprocessTosource(rowData);
      }
      // Send to preflight
      else if (actionType === 2) {
        handleSendToPreflight(rowData);
      }
      // Send to downsample
      else if (actionType === 3) {
        handleSendToDownSample(rowData);
      }
      // Send to E-delivery
      else if (actionType === 4) {
        handleSendToEDelivery(rowData);
      }
      setAnchorEl(null);
    };
    if (params.data === undefined) {
      return "";
    } else {
      return (
        <div>
          {isPagePermission("Allow Download", "Downstream", 205) && (
            <Tooltip title="Click here to download the documents">
              <IconButton
                className="icon-button"
                style={{ padding: ".1vh" }}
                onClick={() => downloadSelectedFiles(rowData)}
              >
                <FileDownloadIcon />
              </IconButton>
            </Tooltip>
          )}
          {isPagePermission("Allow DocumentPreView", "Downstream", 212) && (
            <Tooltip title="Click to view">
              <IconButton
                className="icon-button"
                style={{ padding: ".1vh" }}
                onClick={() => viewDocument(rowData)}
              >
                <VisibilityIcon />
              </IconButton>
            </Tooltip>
          )}
          {isPagePermission(
            "Allow Metadata Information",
            "Downstream",
            207,
          ) && (
            <Tooltip title="Click to view the file information and history">
              <IconButton
                className="icon-button"
                style={{ padding: ".1vh" }}
                onClick={() => infoDocument(rowData)}
              >
                <InfoIcon />
              </IconButton>
            </Tooltip>
          )}

          {emailIcon &&
            isPagePermission("Allow Email Document", "Downstream", 1370) && (
              <Tooltip title="Click to send E-mail">
                <IconButton
                  className="icon-button"
                  style={{ padding: ".1vh" }}
                  onClick={() => viewEmailDocument(rowData)}
                >
                  <MailIcon />
                </IconButton>
              </Tooltip>
            )}

          {isPagePermission("Allow Asset History", "Downstream", 1454) && (
            <Tooltip title="Click to view Asset History">
              <IconButton
                className="icon-button"
                style={{ padding: ".1vh" }}
                onClick={() => viewHistory(rowData)}
              >
                <HistoryIcon />
              </IconButton>
            </Tooltip>
          )}
          {isPagePermission("", "", 1444) && (
            <Tooltip title="Click to view Exceptions">
              <IconButton
                className="icon-button"
                style={{ padding: ".1vh" }}
                onClick={() => viewException(rowData)}
              >
                <SearchIcon />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip title="Please click to view the actions">
            <MoreVertIcon
              className="icon-button"
              onClick={handleClick}
              style={{
                padding: "0.2vh",
                cursor: "pointer",
              }}
            />
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            keepMounted
          >
            {params.data.IsAllowSubSystemReprocess === true &&
              params.data["ACTION CODE"] !== "ARF" &&
              isPagePermission(
                "Allow Reprocess - SubSystem",
                "Downstream",
                1443,
              ) &&
              LocalStorageUtil.getItem("contextName") !==
                "DocDistro_MOAForms" && (
                <MenuItem
                  className="context-menu-item"
                  onClick={() => handleClose(1, rowData)}
                >
                  Reprocess to Source
                </MenuItem>
              )}
            {isPagePermission("Allow Delete", "Downstream", 206) && (
              <MenuItem
                className="context-menu-item"
                onClick={() => handleClose(0, rowData)}
              >
                Delete
              </MenuItem>
            )}
            {LocalStorageUtil.getItem("isAccountDAOEnabled") === "True" &&
              isPagePermission("Allow Send to Preflight", "Downstream", 209) &&
              (params.data.DocumentStatusValue.toUpperCase() ===
                "CURRENT (PRINT-READY VERSION)" ||
                params.data.DocumentStatusValue.toUpperCase() ===
                  "PRINT-READY") && (
                <MenuItem
                  className="context-menu-item"
                  onClick={() => handleClose(2, rowData)}
                >
                  Send to preflight
                </MenuItem>
              )}
            {LocalStorageUtil.getItem("isAccountDAOEnabled") === "True" &&
              isPagePermission("Allow Send to Downsample", "Downstream", 210) &&
              ((params.data.DocumentStatus === 2 &&
                (params.data.DocumentStatusValue.toUpperCase() ===
                  "CURRENT (PRINT-READY VERSION)" ||
                  params.data.DocumentStatusValue.toUpperCase() ===
                    "PRINT-READY")) ||
                params.data.DocumentStatusValue.toUpperCase() === "CURRENT" ||
                params.data.DocumentStatusValue.toUpperCase() ===
                  "WEB-READY") && (
                <MenuItem
                  className="context-menu-item"
                  onClick={() => handleClose(3, rowData)}
                >
                  Send to downsample
                </MenuItem>
              )}
            {LocalStorageUtil.getItem("isAccountDAOEnabled") === "True" &&
              isPagePermission("Allow Send to Edelivery", "Downstream", 211) &&
              (params.data.DocumentStatusValue.toUpperCase() === "CURRENT" ||
                params.data.DocumentStatusValue.toUpperCase() ===
                  "WEB-READY") && (
                <MenuItem
                  className="context-menu-item"
                  onClick={() => handleClose(4, rowData)}
                >
                  Send to E-delivery
                </MenuItem>
              )}
          </Menu>
        </div>
      );
    }
  };

  //File Download - Action buttons events
  const fileDownload = async (params: any) => {
    const objDownloadFile = {
      documentStreamID: params.DocumentStreamID,
      contextName: LocalStorageUtil.getItem("contextName")?.toString(),
    };
    try {
      setLoading(true);
      const response = await downloadFile(objDownloadFile);
      if (response.status === 200) {
        setLoading(false);
        const data = response.data;
        const contentType = response.headers["content-type"];
        const linkElement = document.createElement("a");
        const blob = new Blob([data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        linkElement.href = url;
        linkElement.setAttribute("download", params.DownloadFileName);
        const clickEvent = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false,
        });
        linkElement.dispatchEvent(clickEvent);
      }
      if (response) {
        showSnackbar("Documents downloaded successfully");
      } else {
        showSnackbar("Unable to download file !", true);
      }
    } catch (error) {
      showSnackbar("Something went wrong !!!", true);
    } finally {
      set_DialogOpen(false);
      setLoading(false);
    }
  };

  const downloadSelectedFiles = async (params: any) => {
    if (!gridRef.current) return;
    const selectedRows = gridRef.current.api.getSelectedRows();

    if (selectedRows.length === 0) {
      showSnackbar("Please select at least one file to download.", true);
      return;
    }

    // If only one file is selected, use the existing single file download
    if (selectedRows.length === 1) {
      fileDownload(selectedRows[0]);
      return;
    }

    try {
      let multiFileDownload = null;
      if (selectedRows.length > 1) {
        let documentStreamID: number[] = [];

        selectedRows.forEach((item: any) => {
          documentStreamID.push(item.DocumentStreamID);
        });

        if (documentStreamID.length > 1) {
          multiFileDownload = {
            SearchText: documentStreamID.toString(),
            contextName:
              businessUnitData?.contextName ||
              LocalStorageUtil.getItem("contextName")?.toString(),
          };
        }
      }
      setLoading(true);
      showSnackbar("Download Started");
      // Call your API to get the zip file (implement GetDownloadFiles in your backend)
      const response = await multipleDownloadFile(multiFileDownload);
      if (response.status === 200) {
        const data = response.data;
        const contentType =
          response.headers["content-type"] || "application/zip";
        const fileName = "documents.zip";
        const linkElement = document.createElement("a");
        const blob = new Blob([data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        linkElement.href = url;
        linkElement.setAttribute("download", fileName);
        const clickEvent = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false,
        });
        linkElement.dispatchEvent(clickEvent);
        showSnackbar("Documents downloaded successfully");
      } else {
        showSnackbar("Unable to download file!", true);
      }
    } catch (error) {
      showSnackbar("Something went wrong !!!", true);
    } finally {
      set_DialogOpen(false);
      setLoading(false);
    }
  };

  //Info Document - Action buttons events
  const infoDocument = (rowData: any) => {
    setSelectedDocument(rowData);
    toggleDrawer(true)();
  };

  //View Document - Action buttons events
  const viewDocument = (rowData: any) => {
    const id = rowData.DocumentStreamID;
    const encodedId = btoa(id);
    const fileName = rowData.DownloadFileName.replace(/\.[^/.]+$/, "");
    const url = !urlConfig.isDeployed
      ? `/documentviewer/${encodedId}?FileName=${fileName}`
      : `/docdistrov2/documentviewer/${encodedId}?FileName=${fileName}`;
    popupCenter(url, "Document Viewer Rakesh", 1100, 550);
  };

  const popupCenter = (url: string, title: string, w: number, h: number) => {
    const dualScreenLeft = window.screenLeft ?? window.screenX ?? 0;
    const dualScreenTop = window.screenTop ?? window.screenY ?? 0;

    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      window.screen.width;

    const height =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      window.screen.height;

    const left = width / 3 - w / 3 + dualScreenLeft;
    const top = height / 3 - h / 3 + dualScreenTop;
    const newWindow = window.open(
      url,
      title,
      `readonly=true, scrollbars=yes, width=${w}, height=${h}, top=${top}, left=${left}`,
    );
    if (newWindow) {
      newWindow.focus();
    }
  };

  //History - Action buttons events
  const viewHistory = (rowData: any) => {
    setAssetHistoryData(rowData);
    setAssetHistoryOpen(true);
  };

  // Close AssetHistory
  const closeAssetHistory = () => {
    setAssetHistoryOpen(false);
    setAssetHistoryData(null);
  };

  //Exception - Action buttons events
  const viewException = (rowData: any) => {
    setExceptionData(rowData);
    setExceptionOpen(true);
  };

  //Close Exception
  const closeException = () => {
    setExceptionOpen(false);
    setExceptionData(null);
  };

  //Email Document - Action buttons events
  const viewEmailDocument = (rowData: any) => {
    if (gridRef.current) {
      const selectedRows = gridRef.current.api.getSelectedRows();
      let downstreamrReprocessModel: DownstreamreprocessModel[] = [];

      if (selectedRows.length === 0) {
        const objDownstreamreprocessModel: DownstreamreprocessModel = {
          ProcessType: undefined,
          DocumentStreamId: rowData.DocumentStreamID,
          AccountId: loggedUserData?.accountId,
          UserId: Number(LocalStorageUtil.getItem("userId")),
          FileName: rowData.DownloadFileName,
          Serverpath: undefined,
          DocumentLink: undefined,
          Recipients: undefined,
          CCEmail: undefined,
          Subject: undefined,
          SubSystemConfigurationID: undefined,
          ParentDocumentStreamID: undefined,
          SubSystemName: undefined,
          BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
          ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
          DocumentStatus: rowData.DocumentStatus,
          TimeZone: appSettings.timezone,
        };
        downstreamrReprocessModel.push(objDownstreamreprocessModel);
      } else {
        selectedRows.forEach((rowData) => {
          const objDownstreamreprocessModel: DownstreamreprocessModel = {
            ProcessType: undefined,
            DocumentStreamId: rowData.DocumentStreamID,
            AccountId: loggedUserData?.accountId,
            UserId: Number(LocalStorageUtil.getItem("userId")),
            FileName: rowData.DownloadFileName,
            Serverpath: undefined,
            DocumentLink: undefined,
            Recipients: undefined,
            CCEmail: undefined,
            Subject: undefined,
            SubSystemConfigurationID: undefined,
            ParentDocumentStreamID: undefined,
            SubSystemName: undefined,
            BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
            ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
            DocumentStatus: rowData.DocumentStatus,
            TimeZone: appSettings.timezone,
          };
          downstreamrReprocessModel.push(objDownstreamreprocessModel);
        });
      }
      setEmailDocumentData(downstreamrReprocessModel);
      setEmailDocumentOpen(true);
    }
  };

  const closeEmailDocument = () => {
    setEmailDocumentOpen(false);
    setEmailDocumentData(null);
  };

  // Handel search text change
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 0) {
      setShowIconButton(true);
      setsearchContent(e.target.value);
      set_SearchContentError("");
    } else {
      setShowIconButton(false);
      setsearchContent("");
      set_SearchContentError("Please enter search content");
    }
  };

  // Handel search button click
  const handleSearchSubmit = () => {
    try {
      if (searchContent.trim().length > 0) {
        set_SearchContentError("");
        const parameter: PreworksummaryModelDetails = {
          AccountId: businessUnitData?.accountId || loggedUserData?.accountId,
          Fromdate: startDate,
          Todate: endDate,
          Search: searchContent,
          SortColumn: "",
          SortOrder: 0,
          Documentstatus: tabType,
          CurrentPage: 0,
          NoOfRecords: 0,
          Datebasedocid: undefined,
          Timezone: appSettings.timezone,
          PageLoadFlag: true,
          UserId: Number(LocalStorageUtil.getItem("userId")),
          IsSuperAdmin: 1,
          FolderRights: false,
          ContextName:
            businessUnitData?.contextName ||
            LocalStorageUtil.getItem("contextName")?.toString(),
        };
        fetchData(parameter);
      } else {
        set_SearchContentError("Please enter search content");
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Handel search content clear
  const handelSearchContentClear = () => {
    setsearchContent("");
    set_SearchContentError("");
    setShowIconButton(false);
    try {
      const parameter: PreworksummaryModelDetails = {
        AccountId: businessUnitData?.accountId || loggedUserData?.accountId,
        Fromdate: startDate,
        Todate: endDate,
        Search: undefined,
        SortColumn: "",
        SortOrder: 0,
        Documentstatus: tabType,
        CurrentPage: 0,
        NoOfRecords: 0,
        Datebasedocid: undefined,
        Timezone: appSettings.timezone,
        PageLoadFlag: true,
        UserId: Number(LocalStorageUtil.getItem("userId")),
        IsSuperAdmin: 1,
        FolderRights: false,
        ContextName:
          businessUnitData?.contextName ||
          LocalStorageUtil.getItem("contextName")?.toString(),
      };
      fetchData(parameter);
    } catch (error) {
      console.log(error);
    }
  };

  // Search content on enter key press
  const handleSearchKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearchSubmit();
    }
  };

  const refreshGridData = () => {
    if (tabType === 2) {
      handleInProcessTabClick(2, "IN-PROCESS");
    } else if (tabType === 3) {
      handleCompletedTabClick(3, "COMPLETED");
    } else if (tabType === 0) {
      handleAllTabClick(0, "ALL");
    }
  };

  //#region Context Menu
  const [deleteConfirmationDialogOpen, setdeleteConfirmationDialogOpen] =
    useState(false);
  const [deleteDocumentData, setDeleteDocumentData] = useState<any>(null);
  const [isArfMessage, setIsArfMessage] = useState(false);
  const [reprocessSubSystemOpen, setReprocessSubSystemOpen] = useState(false);
  const [reprocessSubSystemOpenData, setReprocessSubSystemOpenData] =
    useState<any>(null);
  const [reprocessFDOpen, setReprocessFDOpen] = useState(false);
  const [reprocessFDOpenData, setReprocessFDOpenData] = useState<any>(null);
  const [reprocessEDeliveryOpen, setReprocessEDeliveryOpen] = useState(false);
  const [reprocessEDeliveryOpenData, setReprocessEDeliveryOpenData] =
    useState<any>(null);

  //Close Confirmation Delete Dialog
  const closeConfirmationDialogbox = (isCancelClick: boolean) => {
    setdeleteConfirmationDialogOpen(false);
    setDeleteDocumentData(null);
    if (isCancelClick) {
      refreshGridData();
    }
  };

  //Close Reprocess SubSystem Dialog
  const closeReprocessSubSystemDialogbox = (isCancelClick: boolean) => {
    setReprocessSubSystemOpen(false);
    setReprocessSubSystemOpenData(null);
    if (isCancelClick) {
      refreshGridData();
    }
  };

  //Close Reprocess FD Dialog
  const closeReprocessFDDialogbox = (isCancelClick: boolean) => {
    setReprocessFDOpen(false);
    setReprocessFDOpenData(null);
    if (isCancelClick) {
      refreshGridData();
    }
  };

  //Close Reprocess E-Delivery Dialog
  const closeReprocessEDeliveryDialogbox = (isCancelClick: boolean) => {
    setReprocessEDeliveryOpen(false);
    setReprocessEDeliveryOpenData(null);
    if (isCancelClick) {
      refreshGridData();
    }
  };

  // Helper to build ARFDocument from a row
  function buildArfDocument(row: any): ARFDocument {
    return {
      AccountId: Number(LocalStorageUtil.getItem("accountId")),
      DocumentStreamId: row["DocumentStreamID"] ?? row.DocumentStreamID,
      UserId: Number(LocalStorageUtil.getItem("userId")),
      ProjectDocumentIds: row["Document ID"] ?? row.DocumentID,
      ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
    };
  }

  // Helper to handle ARF response and dialog state
  function handleArfResponse(
    arfDocuments: ARFDocument[],
    arfDocumentResponse: boolean,
    setDeleteDocumentData: (docs: ARFDocument[]) => void,
    setdeleteConfirmationDialogOpen: (open: boolean) => void,
    setIsArfMessage: (isArf: boolean) => void,
  ) {
    setDeleteDocumentData(arfDocuments);
    setdeleteConfirmationDialogOpen(true);
    setIsArfMessage(!!arfDocumentResponse);
  }

  const handelDeleteContextMenuOption = async (rowsData: any) => {
    setLoading(true);
    let arfDocuments: ARFDocument[] = [];
    if (!gridRef.current) return;

    let selectedRows = gridRef.current.api.getSelectedRows();
    selectedRows = selectedRows.length > 0 ? selectedRows : rowsData;

    let actionCode: string = "";
    if (Array.isArray(selectedRows)) {
      actionCode = selectedRows[0]?.["ACTION CODE"]?.toLowerCase() ?? "";
    } else {
      actionCode = selectedRows["ACTION CODE"];
    }

    const isArfAction = actionCode?.toLowerCase() === "arf";

    // Build ARF documents array
    if (Array.isArray(selectedRows)) {
      if (selectedRows.length === 0 && rowsData) {
        arfDocuments.push(buildArfDocument(rowsData));
      } else {
        selectedRows.forEach((row: any) => {
          arfDocuments.push(buildArfDocument(row));
        });
      }
    } else if (selectedRows && typeof selectedRows === "object") {
      arfDocuments.push(buildArfDocument(selectedRows));
    }

    // If ARF action, use rowsData for single selection
    if (
      isArfAction &&
      (selectedRows.length === undefined || selectedRows.length === 1)
    ) {
      arfDocuments = [buildArfDocument(rowsData)];
    }

    if (arfDocuments.length > 0) {
      const arfDocumentResponse = await GetARFDocuments(arfDocuments);
      handleArfResponse(
        arfDocuments,
        arfDocumentResponse === true,
        setDeleteDocumentData,
        setdeleteConfirmationDialogOpen,
        setIsArfMessage,
      );
    }
  };

  //Handel reprocess to source
  const handleReprocessTosource = async (rowsData: any) => {
    if (gridRef.current) {
      const selectedRows = gridRef.current.api.getSelectedRows();
      let downstreamrReprocessModel: DownstreamreprocessModel[] = [];
      if (selectedRows.length === 0) {
        const objDownstreamreprocessModel: DownstreamreprocessModel = {
          ProcessType: undefined,
          DocumentStreamId: rowsData.DocumentStreamID,
          AccountId: loggedUserData?.accountId,
          UserId: Number(LocalStorageUtil.getItem("userId")),
          FileName: rowsData.DownloadFileName,
          Serverpath: undefined,
          DocumentLink: undefined,
          Recipients: undefined,
          CCEmail: undefined,
          Subject: undefined,
          SubSystemConfigurationID:
            rowsData.SubSystemConfigurationId.toString() ?? "",
          ParentDocumentStreamID:
            rowsData.ParentDocumentStreamID === null
              ? ""
              : rowsData.ParentDocumentStreamID.toString(),
          SubSystemName: rowsData.SubSystemName.toString(),
          BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
          ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
          DocumentStatus: rowsData.DocumentStatus,
          TimeZone: "Central America Standard Time",
        };
        downstreamrReprocessModel.push(objDownstreamreprocessModel);
      } else {
        selectedRows.forEach((rowData) => {
          const objDownstreamreprocessModel: DownstreamreprocessModel = {
            ProcessType: undefined,
            DocumentStreamId: rowData.DocumentStreamID,
            AccountId: loggedUserData?.accountId,
            UserId: Number(LocalStorageUtil.getItem("userId")),
            FileName: rowData.DownloadFileName,
            Serverpath: undefined,
            DocumentLink: undefined,
            Recipients: undefined,
            CCEmail: undefined,
            Subject: undefined,
            SubSystemConfigurationID:
              rowsData.SubSystemConfigurationId.toString() ?? "",
            ParentDocumentStreamID:
              rowsData.ParentDocumentStreamID === null
                ? ""
                : rowsData.ParentDocumentStreamID.toString(),
            SubSystemName: rowsData.SubSystemName.toString(),
            BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
            ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
            DocumentStatus: rowData.DocumentStatus,
            TimeZone: "Central America Standard Time",
          };
          downstreamrReprocessModel.push(objDownstreamreprocessModel);
        });
      }
      if (
        downstreamrReprocessModel !== undefined &&
        downstreamrReprocessModel.length > 0
      ) {
        setReprocessSubSystemOpenData(downstreamrReprocessModel);
        setReprocessSubSystemOpen(true);
      } else {
        showSnackbar("No document selected to reprocess", true);
      }
    }
  };

  //Handel send to preflight
  const handleSendToPreflight = async (rowsData: any) => {
    if (gridRef.current) {
      const selectedRows = gridRef.current.api.getSelectedRows();
      let downstreamrReprocessModel: DownstreamreprocessModel[] = [];
      if (selectedRows.length === 0) {
        const objDownstreamreprocessModel: DownstreamreprocessModel = {
          ProcessType: 1,
          DocumentStreamId: rowsData.DocumentStreamID,
          AccountId: loggedUserData?.accountId,
          UserId: Number(LocalStorageUtil.getItem("userId")),
          FileName: rowsData.DownloadFileName,
          Serverpath: undefined,
          DocumentLink: undefined,
          Recipients: undefined,
          CCEmail: undefined,
          Subject: undefined,
          SubSystemConfigurationID: undefined,
          ParentDocumentStreamID: undefined,
          SubSystemName: undefined,
          BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
          ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
          DocumentStatus: rowsData.DocumentStatus,
          TimeZone: "Central America Standard Time",
        };
        downstreamrReprocessModel.push(objDownstreamreprocessModel);
      } else {
        selectedRows.forEach((rowData) => {
          const objDownstreamreprocessModel: DownstreamreprocessModel = {
            ProcessType: 1,
            DocumentStreamId: rowData.DocumentStreamID,
            AccountId: loggedUserData?.accountId,
            UserId: Number(LocalStorageUtil.getItem("userId")),
            FileName: rowData.DownloadFileName,
            Serverpath: undefined,
            DocumentLink: undefined,
            Recipients: undefined,
            CCEmail: undefined,
            Subject: undefined,
            SubSystemConfigurationID: undefined,
            ParentDocumentStreamID: undefined,
            SubSystemName: undefined,
            BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
            ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
            DocumentStatus: rowData.DocumentStatus,
            TimeZone: "Central America Standard Time",
          };
          downstreamrReprocessModel.push(objDownstreamreprocessModel);
        });
      }
      if (
        downstreamrReprocessModel !== undefined &&
        downstreamrReprocessModel.length > 0
      ) {
        setReprocessFDOpenData(downstreamrReprocessModel);
        setReprocessFDOpen(true);
      } else {
        showSnackbar("No FD document selected to reprocess", true);
      }
    }
  };

  //Handel send to downsample
  const handleSendToDownSample = async (rowsData: any) => {
    if (gridRef.current) {
      const selectedRows = gridRef.current.api.getSelectedRows();
      let downstreamrReprocessModel: DownstreamreprocessModel[] = [];
      if (selectedRows.length === 0) {
        const objDownstreamreprocessModel: DownstreamreprocessModel = {
          ProcessType: 2,
          DocumentStreamId: rowsData.DocumentStreamID,
          AccountId: loggedUserData?.accountId,
          UserId: Number(LocalStorageUtil.getItem("userId")),
          FileName: rowsData.DownloadFileName,
          Serverpath: undefined,
          DocumentLink: undefined,
          Recipients: undefined,
          CCEmail: undefined,
          Subject: undefined,
          SubSystemConfigurationID: undefined,
          ParentDocumentStreamID: undefined,
          SubSystemName: undefined,
          BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
          ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
          DocumentStatus: rowsData.DocumentStatus,
          TimeZone: "Central America Standard Time",
        };
        downstreamrReprocessModel.push(objDownstreamreprocessModel);
      } else {
        selectedRows.forEach((rowData) => {
          const objDownstreamreprocessModel: DownstreamreprocessModel = {
            ProcessType: 2,
            DocumentStreamId: rowData.DocumentStreamID,
            AccountId: loggedUserData?.accountId,
            UserId: Number(LocalStorageUtil.getItem("userId")),
            FileName: rowData.DownloadFileName,
            Serverpath: undefined,
            DocumentLink: undefined,
            Recipients: undefined,
            CCEmail: undefined,
            Subject: undefined,
            SubSystemConfigurationID: undefined,
            ParentDocumentStreamID: undefined,
            SubSystemName: undefined,
            BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
            ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
            DocumentStatus: rowData.DocumentStatus,
            TimeZone: "Central America Standard Time",
          };
          downstreamrReprocessModel.push(objDownstreamreprocessModel);
        });
      }
      if (
        downstreamrReprocessModel !== undefined &&
        downstreamrReprocessModel.length > 0
      ) {
        setReprocessFDOpenData(downstreamrReprocessModel);
        setReprocessFDOpen(true);
      } else {
        showSnackbar("No FD document selected to reprocess", true);
      }
    }
  };

  //Handel send to e-delivery
  const handleSendToEDelivery = async (rowsData: any) => {
    if (gridRef.current) {
      const selectedRows = gridRef.current.api.getSelectedRows();
      let downstreamrReprocessModel: DownstreamreprocessModel[] = [];
      if (selectedRows.length === 0) {
        const objDownstreamreprocessModel: DownstreamreprocessModel = {
          ProcessType: 0,
          DocumentStreamId: rowsData.DocumentStreamID,
          AccountId: loggedUserData?.accountId,
          UserId: Number(LocalStorageUtil.getItem("userId")),
          FileName: rowsData.DownloadFileName,
          Serverpath: undefined,
          DocumentLink: undefined,
          Recipients: undefined,
          CCEmail: undefined,
          Subject: undefined,
          SubSystemConfigurationID: undefined,
          ParentDocumentStreamID: undefined,
          SubSystemName: undefined,
          BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
          ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
          DocumentStatus: rowsData.DocumentStatus,
          TimeZone: "Central America Standard Time",
        };
        downstreamrReprocessModel.push(objDownstreamreprocessModel);
      } else {
        selectedRows.forEach((rowData) => {
          const objDownstreamreprocessModel: DownstreamreprocessModel = {
            ProcessType: 0,
            DocumentStreamId: rowData.DocumentStreamID,
            AccountId: loggedUserData?.accountId,
            UserId: Number(LocalStorageUtil.getItem("userId")),
            FileName: rowData.DownloadFileName,
            Serverpath: undefined,
            DocumentLink: undefined,
            Recipients: undefined,
            CCEmail: undefined,
            Subject: undefined,
            SubSystemConfigurationID: undefined,
            ParentDocumentStreamID: undefined,
            SubSystemName: undefined,
            BusinessUnitId: Number(LocalStorageUtil.getItem("businessUnitId")),
            ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
            DocumentStatus: rowData.DocumentStatus,
            TimeZone: "Central America Standard Time",
          };
          downstreamrReprocessModel.push(objDownstreamreprocessModel);
        });
      }
      if (
        downstreamrReprocessModel !== undefined &&
        downstreamrReprocessModel.length > 0
      ) {
        setReprocessEDeliveryOpenData(downstreamrReprocessModel);
        setReprocessEDeliveryOpen(true);
      } else {
        showSnackbar("No FD document selected to reprocess", true);
      }
    }
  };

  //#endregion

  // Render the component
  return (
    <div style={{ overflow: "hidden" }}>
      <NavigationBar
        menuTitle="Queue Managment"
        screenTitle=""
        title="Downstream Summary"
        text="Downstream Summary"
      />
      <Row style={{ marginLeft: "1em" }}>
        <Col>
          <Box>
            <div className="rp-main-inner col-sm-12">
              <div className="queue-top row clearfix">
                {/* Buttons */}
                <div
                  className="col-sm-8"
                  style={{
                    display: "flex",
                    gap: ".3em",
                    alignItems: "center",
                    marginTop: ".5em",
                    width: "66%",
                    fontSize: "11px",
                  }}
                >
                  {isPagePermission(
                    "Allow Downstream Inprogress",
                    "Downstream",
                    1344,
                  ) && (
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => handleInProcessTabClick(2, "IN-PROCESS")}
                      style={{
                        backgroundColor:
                          activeButton === "IN-PROCESS" ? "#ddd" : "#4D7BA7",
                        color: activeButton === "IN-PROCESS" ? "black" : "#ddd",
                        marginRight: "1em",
                        fontSize: "11px",
                        borderRadius: "4px",
                        border: "1px solid #858c94",
                        height: "25px",
                      }}
                    >
                      IN-PROCESS({inProcessCount})
                    </Button>
                  )}

                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleCompletedTabClick(3, "COMPLETED")}
                    style={{
                      backgroundColor:
                        activeButton === "COMPLETED" ? "#ddd" : "#4D7BA7",
                      color: activeButton === "COMPLETED" ? "black" : "#ddd",
                      marginRight: "1em",
                      fontSize: "11px",
                      borderRadius: "4px",
                      border: "1px solid #858c94",
                      height: "25px",
                    }}
                  >
                    COMPLETED({completedCount})
                  </Button>

                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleAllTabClick(0, "ALL")}
                    style={{
                      backgroundColor:
                        activeButton === "ALL" ? "#ddd" : "#4D7BA7",
                      color: activeButton === "ALL" ? "black" : "#ddd",
                      fontSize: "11px",
                      borderRadius: "4px",
                      border: "1px solid #858c94",
                      height: "25px",
                    }}
                  >
                    ALL({allCount})
                  </Button>
                </div>
                <div
                  className="col-sm-4"
                  style={{
                    display: "flex",
                    alignItems: "right",
                    content: "flex-end",
                    justifyContent: "flex-end",
                    width: "32.5%",
                    fontSize: "11px",
                    marginTop: ".7em",
                    height: "2.10em",
                  }}
                >
                  <input
                    type="text"
                    placeholder="Search"
                    value={searchContent}
                    onChange={handleSearchChange}
                    onKeyDown={handleSearchKeyPress}
                    className="searchInput"
                    style={{
                      width: "70%",
                      height: "2.25em",
                      padding: "0.5em",
                    }}
                  />
                  <Tooltip title="Please click to search">
                    <button
                      onClick={handleSearchSubmit}
                      className="searchButton"
                    >
                      <SearchIcon style={{ color: "#006ab6" }} />
                    </button>
                  </Tooltip>
                  {showIconButton && (
                    <Tooltip title="Clear to reset search result">
                      <ClearIcon
                        onClick={handelSearchContentClear}
                        style={{
                          height: "1em",
                          width: "1em",
                          color: "var(--text-color)",
                        }}
                      />
                    </Tooltip>
                  )}
                </div>

                <div
                  className="col-sm-12"
                  style={{
                    display: "flex",
                    gap: ".3em",
                    alignItems: "center",
                    marginTop: ".1em",
                    fontSize: "14px",
                  }}
                >
                  {/* Dates, Apply and Reset buttons */}
                  <div
                    className="col-sm-8"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: ".5em",
                    }}
                  >
                    <InputLabel
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        color: "var(--text-color)",
                        display: "inline-block !important",
                        marginBottom: "5px !important",
                        fontWeight: 600,
                        fontSize: "11px",
                        marginTop: ".7em",
                      }}
                    >
                      From Date: *
                    </InputLabel>
                    <Form.Control
                      type="date"
                      placeholder="From Date"
                      name="fromdate"
                      max={new Date().toISOString().split("T")[0]}
                      value={
                        startDate ? startDate.toISOString().split("T")[0] : ""
                      }
                      onChange={(e) => setStartDate(new Date(e.target.value))}
                      style={{
                        padding: ".3em",
                        width: "15%",
                        fontSize: "11px",
                        borderRadius: "0",
                        border: "1px solid #ccc",
                        borderColor: "black",
                        marginTop: ".7em",
                      }}
                    />
                    <InputLabel
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        color: "var(--text-color)",
                        display: "inline-block !important",
                        marginBottom: "5px !important",
                        fontWeight: 600,
                        fontSize: "11px",
                        marginTop: ".7em",
                      }}
                    >
                      To Date: *
                    </InputLabel>
                    <Form.Control
                      type="date"
                      placeholder="To Date"
                      name="todate"
                      value={endDate ? endDate.toISOString().split("T")[0] : ""}
                      max={new Date().toISOString().split("T")[0]}
                      onChange={(e) => setEndDate(new Date(e.target.value))}
                      style={{
                        padding: ".3em",
                        width: "15%",
                        fontSize: "11px",
                        borderRadius: "0",
                        border: "1px solid #ccc",
                        borderColor: "black",
                        marginTop: ".7em",
                      }}
                    />
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleApplyButton}
                      className="button"
                    >
                      Apply
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleReset}
                      className="button"
                    >
                      Reset
                    </Button>
                  </div>

                  {/* Grid Preferences and export to excel */}
                  <div
                    className="col-sm-4"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      content: "flex-end",
                      justifyContent: "flex-end",
                      width: "32%",
                    }}
                  >
                    {gridRecordExist && (
                      <>
                        <Tooltip title="Click to save grid state">
                          <IconButton
                            onClick={handleSaveGridPreferences}
                            className="preference-icon"
                          >
                            <PushPinIcon />
                          </IconButton>
                        </Tooltip>
                        {isPagePermission(
                          "Allow Export To Excel",
                          "Downstream",
                          204,
                        ) && (
                          <Tooltip title="Click to export the grid content in excel">
                            <button
                              type="button"
                              onClick={handleExport}
                              style={{
                                background: "none",
                                border: "none",
                                padding: 0,
                                cursor: "pointer",
                              }}
                              aria-label="Export to Excel"
                            >
                              <img
                                src={ExcelIcon}
                                alt="Doc-Distro"
                                className="excel-icon"
                              />
                            </button>
                          </Tooltip>
                        )}
                      </>
                    )}
                  </div>
                </div>
                {/* Default label text */}
                <div
                  className="col-sm-12"
                  style={{
                    display: "flex",
                    gap: "5px",
                    alignItems: "center",
                    marginTop: ".5em",
                  }}
                >
                  {" "}
                  <InputLabel
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      color: "var(--text-color)",
                      display: "inline-block !important",
                      marginBottom: "5px !important",
                      fontWeight: 600,
                      fontSize: "11px",
                    }}
                  >
                    *Default Load Range is 2 Days
                  </InputLabel>
                </div>
                {/* FD Notebar */}
                {isAccountDAOEnabled && (
                  <div
                    className="retrun_status_notebar bubbles-holder1 col-sm-11 display-note"
                    style={{ width: "97.5%" }}
                  >
                    <span className="export_circle"></span>: Exported |{" "}
                    <span className="return_circle"></span>: Returned |{" "}
                    <span className="exportnotrequired_circle"></span>: Export
                    Not Required | P: Print | D: Downsample | E: eDelivery |
                  </div>
                )}
                {/* AgGrid */}
                <div className="queue-table-view clearfix">
                  <div
                    className="ag-theme-quartz-dark"
                    style={{
                      height: isAccountDAOEnabled === true ? "70vh" : "66vh",
                      width: "99%",
                      marginTop: ".1vh",
                    }}
                  >
                    <AgGridReact
                      columnDefs={columnDefs}
                      rowData={rowData}
                      ref={gridRef}
                      pagination={true}
                      paginationPageSize={defaulPageSize}
                      paginationPageSizeSelector={pageSizeSelector}
                      gridOptions={{
                        rowSelection: {
                          mode: "multiRow",
                          checkboxes: true,
                          headerCheckbox: true,
                          enableClickSelection: false,
                        },
                      }}
                      headerHeight={30}
                      rowGroupPanelShow="always"
                      pivotPanelShow="always"
                      overlayNoRowsTemplate={
                        '<span class="ag-overlay-loading-center">No rows to show</span>'
                      }
                      loading={!rowData || showLoader}
                      loadingOverlayComponent={CustomLoadingOverlay}
                      onGridReady={async (params) => {
                        set_GridApi(params.api);
                        const gridPreferences = await getUserGridPreferences();
                        if (gridPreferences) {
                          applyGridPreferences(gridPreferences);
                        }
                      }}
                    />
                  </div>
                </div>
                {/* Info Drawer */}
                <div>
                  <InfoDrawer
                    isOpen={drawerOpen}
                    onClose={toggleDrawer(false)}
                    title="Document Info"
                    tabLabels={["Information", "Version History"]}
                    selectedDocument={selectedDocument}
                  />
                </div>
              </div>
            </div>

            {/* Assest History popup */}
            {assetHistoryOpen && (
              <AssetHistory
                isOpen={assetHistoryOpen}
                onClose={closeAssetHistory}
                title=""
                selectedData={assetHistoryData}
              />
            )}

            {/* Exception popup */}
            {exceptionOpen && (
              <CopyToClipboardPopup
                isOpen={exceptionOpen}
                onClose={closeException}
                title="Exception"
                selectedData={exceptionData}
              />
            )}

            {/* Email popup */}
            {emailDocumentOpen && (
              <EmailDocument
                isOpen={emailDocumentOpen}
                onClose={closeEmailDocument}
                title="New Message"
                selectedData={emailDocumentData}
              />
            )}

            {/* Delete Confirmation dialogbox */}
            {deleteConfirmationDialogOpen && (
              <ConfirmationAlert
                isOpen={deleteConfirmationDialogOpen}
                onClose={closeConfirmationDialogbox}
                title="Delete Confirmation"
                selectedData={deleteDocumentData}
                isArf={isArfMessage}
                screen="DownstreamSummary"
              />
            )}

            {/* Reprocess SubSystem dialogbox */}
            {reprocessSubSystemOpen && (
              <DownstreamSubSystemReprocessPopup
                isOpen={reprocessSubSystemOpen}
                onClose={closeReprocessSubSystemDialogbox}
                title="Reprocess"
                selectedData={reprocessSubSystemOpenData}
                documentStatusFlag={false}
              />
            )}

            {/* Reprocess Downsample and Preflight  */}
            {reprocessFDOpen && (
              <DownstreamFDReprocesspopup
                isOpen={reprocessFDOpen}
                onClose={closeReprocessFDDialogbox}
                title="Reprocess"
                selectedData={reprocessFDOpenData}
                value={1}
              />
            )}

            {/* Reprocess EDelivery */}
            {reprocessEDeliveryOpen && (
              <DownstreamFDReprocesspopup
                isOpen={reprocessEDeliveryOpen}
                onClose={closeReprocessEDeliveryDialogbox}
                title="Reprocess"
                selectedData={reprocessEDeliveryOpenData}
                value={2}
              />
            )}
          </Box>
        </Col>
      </Row>
    </div>
  );
};

export default DownstreamSummary;
